import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import BotonInformacion from "../../../components/helpers/BotonInformacion";
import Spinner from "../../../components/helpers/Spinner";
import { ShowDateToUser } from "../../../components/ShowDateToUser";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import { verifyToken } from "../../../redux/reducers/authReducer";
import { getHouse } from "../../../redux/reducers/onboardingReducer";
import { Navbar } from "../Navbar";
import { NavbarMobile } from "../NavbarMobile";
import { useDispatchDominio } from "../../../hooks/useDispatchDominio";
import { ButtonRegresar } from "../../../components/ButtonRegresar";
import { useParams } from "react-router-dom";
import { NavbarBroker } from "../../dashboardBroker/NavbarBroker";
import { NavbarMobileBroker } from "../../dashboardBroker/NavbarMobileBroker";
import { NavbarHotel } from "../../dashboardHotel/NavbarHotel";
import { NavbarMobileHotel } from "../../dashboardHotel/NavbarMobileHotel";

interface Check {
    garantia: string;
    precio_base: string;
    tipo_moneda: string;
    tipo_garantia: string;
    check_in: string;
    check_out: string;
    nombre: string;
}

export const CheckInCheckOut = () => {
    const { idCasa } = useParams();
    const { tipo_usuario } = useAppSelector((state) => state.usuario_logeado);
    const dispatchDominio = useDispatchDominio(
        tipo_usuario === 8
            ? undefined
            : idCasa && Number(idCasa) > 0
            ? idCasa
            : undefined
    );

    const {
        id: id_casa,
        check_out,
        check_in,
        id_propietario,
    } = useAppSelector((state) => state.landing_house.house);

    useEffect(() => {
        if (tipo_usuario === 3 || tipo_usuario === 4 || tipo_usuario === 6) {
            if (idCasa && Number(idCasa) > 0) dispatchDominio();
        }
    }, []);
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);

    const [input, setInput] = useState<Check>({
        garantia: "",
        precio_base: "",
        tipo_moneda: "",
        tipo_garantia: "",
        check_in: "",
        check_out: "",
        nombre: "",
    });

    const getHabitacion = async () => {
        if (idCasa) {
            const data = await fetchAxiosToken({
                url: `/hotel_habitaciones/detalle/${idCasa}`,
            });

            setInput(data);
        }
    };

    const putMaximaBase = async () => {
        setLoading(true);
        if (input.check_in === "" || input.check_out === "") {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Debes completar check-in y check-out ",

                icon: "error",
                confirmButtonText: "Ok",
            });
            return;
        }
        try {
            if (tipo_usuario === 8) {
                await fetchAxiosToken({
                    url: `/hotel_habitaciones/updatePrecio/${idCasa}`,
                    method: "put",
                    body: input,
                });
            } else {
                await fetchAxiosToken({
                    url: `/casa/putCheck/${id_casa}`,
                    method: "put",
                    body: input,
                });
            }

            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Actualizado con exito",

                icon: "success",
                confirmButtonText: "Ok",
            });

            dispatchDominio();

            setLoading(false);
        } catch (error: any) {
            console.log(error.response);
        }
    };

    useEffect(() => {
        if (tipo_usuario === 3 || tipo_usuario === 4 || tipo_usuario === 6) {
            setInput({
                ...input,
                check_in: check_in,
                check_out: check_out,
            });
        } else if (tipo_usuario === 8) {
            getHabitacion();
        }
    }, [check_out]);

    const render = () => {
        return (
            <div className="flex">
                {true ? (
                    <div className="grid w-full max-w-6xl mx-auto mt-12 lg:grid-cols-2 right-2 ">
                        <div className="  text-[#4D4D4D]">
                            <ButtonRegresar
                                // url={`/dashboard/onboarding/alojamiento`}
                                className="-ml-2 "
                                arrowColor="black"
                                textColor="black"
                            />
                            <p className="text-xl font-bold 2xl:text-2xl ">
                                Check-in y Check-out
                            </p>
                            <p className="mt-6 text-sm 2xl:text-base">
                                Establece el horario de entrada y salida para
                                los huéspedes.
                            </p>
                        </div>
                        <div className="p-4 border rounded-lg shadow-2xl ">
                            <div className="grid w-full grid-cols-2 gap-2 lg:gap-5">
                                <div>
                                    <div className="mt-5 mb-2 ml-2 2xl:text-base text-sm italic text-[#4D4D4D] font-medium">
                                        <p>Check-In</p>
                                    </div>
                                    <div className="flex items-center text-base italic text-gray-500 border-2  border-[#CCCCCC] w-full rounded-lg outline-none">
                                        <input
                                            type="time"
                                            placeholder="Dias"
                                            onChange={(e) =>
                                                setInput({
                                                    ...input,
                                                    check_in: e.target.value,
                                                })
                                            }
                                            className=" 2xl:p-2 p-1.5 outline-none cursor-pointer text-[#3C3C3C] rounded-lg w-full 2xl:text-base text-sm"
                                            value={input.check_in}
                                        />
                                    </div>
                                </div>

                                <div className="w-full">
                                    <div className="mt-5 mb-2 ml-2 2xl:text-base text-sm italic text-[#4D4D4D] font-medium ">
                                        <p>Check-Out</p>
                                    </div>
                                    <div className="flex items-center 2xl:text-base text-sm italic text-gray-500 border-2  border-[#CCCCCC] w-full rounded-lg outline-none">
                                        <input
                                            type="time"
                                            placeholder="Dias"
                                            onChange={(e) =>
                                                setInput({
                                                    ...input,
                                                    check_out: e.target.value,
                                                })
                                            }
                                            className=" 2xl:p-2 p-1.5 2xl:text-base text-sm outline-none cursor-pointer text-[#3C3C3C] rounded-lg w-full"
                                            value={input.check_out}
                                        />
                                    </div>
                                </div>

                                <div className="flex justify-center w-full ">
                                    <div className="relative flex items-center justify-center w-full">
                                        {/* <BotonInformacion text="Ingresa los horarios de entrada Y salida para que tus clientes puedan verlo!" /> */}
                                        <button
                                            disabled={loading}
                                            onClick={() => putMaximaBase()}
                                            className="w-full px-2 py-[11px] uppercase font-medium text-white rounded-lg bg-[#029BFC] active:translate-y-1 disabled:translate-y-0 disabled:from-slate-400 disabled:to-gray-400 disabled:cursor-default 2xl:text-base text-sm"
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="mt-8">
                        <Spinner />
                    </div>
                )}
            </div>
        );
    };

    return tipo_usuario === 3 || tipo_usuario === 4 ? (
        <Navbar titulo="Check-In Check-Out">
            {render()}
            <NavbarMobile />
        </Navbar>
    ) : tipo_usuario === 6 ? (
        <NavbarBroker titulo="Check-In Check-Out">
            {render()}
            <NavbarMobileBroker />
        </NavbarBroker>
    ) : tipo_usuario === 8 ? (
        <NavbarHotel titulo={`Check-In Check-Out ${input.nombre} `}>
            {render()}
            <NavbarMobileHotel />
        </NavbarHotel>
    ) : null;
};
